import { t } from 'i18next';
import * as yup from 'yup';

export const complianceDocumentTypeSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
  externalId: yup.string().trim().notRequired(),
  description: yup.string().trim().notRequired(),
  fieldType: yup.string().required(),
  hasExpiration: yup.boolean().required(),
  dispatchGating: yup.boolean().required(),
  requiredVendors: yup.boolean().required(),
  requiredInternalDrivers: yup.boolean().required(),
  requiredSharedDrivers: yup.boolean().required(),
  requiredEquipment: yup.boolean().required(),
});

export type ComplianceDocumentTypeDto = yup.InferType<
  typeof complianceDocumentTypeSchema
>;

export type ComplianceDocumentTypeDtoAsyncError = {
  field: keyof ComplianceDocumentTypeDto;
  message: string;
};
